import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../../utils/constants';

const AdminLogin = () => {
  const [form, setForm] = useState({ email: '', password: '' });
  const [showPwd, setShowPwd] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      // Step 1: login
      console.log(`${API_BASE_URL}/api/admin/login`)
      const res = await fetch(`${API_BASE_URL}/api/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
        credentials: 'include'
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Login failed');
      localStorage.setItem('adminAuth', 'true');
      if (data.token) {
        localStorage.setItem('adminToken', data.token); // optional, if you still want Bearer
      }
      if (data.expiresAt) {
        localStorage.setItem('adminExpiresAt', String(data.expiresAt));
      }

      // Step 3: optional test protected route
      try {
        const meRes = await fetch(`${API_BASE_URL}/api/admin/me`, {
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include'
        });
        if (meRes.ok) {
          console.log('✅ Verified protected route:', await meRes.json());
        } else {
          console.warn('⚠️ Failed protected route check', await meRes.text());
        }
      } catch (innerErr) {
        console.warn('Protected route test error:', innerErr);
      }

      // Step 4: navigate to dashboard
      navigate('/admin/dashboard');
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="p-6 max-w-md mx-auto">
      <h1 className="text-2xl font-bold mb-6 text-center">Admin Login</h1>
      <form onSubmit={handleSubmit} className="space-y-4">
        <input
          type="email"
          name="email"
          placeholder="Email"
          value={form.email}
          onChange={handleChange}
          required
          className="w-full border p-2 rounded"
        />
        <div className="relative">
          <input
            type={showPwd ? 'text' : 'password'}
            name="password"
            placeholder="Password"
            value={form.password}
            onChange={handleChange}
            required
            autoComplete="current-password"
            className="w-full border p-2 pr-10 rounded"
          />
          <button
            type="button"
            aria-label={showPwd ? 'Hide password' : 'Show password'}
            onClick={() => setShowPwd((v) => !v)}
            className="absolute inset-y-0 right-2 my-auto h-8 w-8 grid place-items-center rounded hover:bg-gray-100"
            title={showPwd ? 'Hide password' : 'Show password'}
          >
            {/* Eye icon (tailwind-friendly, no external deps) */}
            {showPwd ? (
              // Eye-off
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5"
                   viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M3 3l18 18" />
                <path d="M10.584 10.59A4 4 0 0012 16a4 4 0 003.995-3.8M9.88 4.253A10.94 10.94 0 0112 4c5.523 0 10 4.477 10 10 0 1.223-.218 2.394-.617 3.474M6.609 6.61C4.052 8.166 2 10.852 2 14c0 0 3.5 6 10 6 1.64 0 3.185-.331 4.58-.93" />
              </svg>
            ) : (
              // Eye
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5"
                   viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z" />
                <circle cx="12" cy="12" r="3" />
              </svg>
            )}
          </button>
        </div>
        {error && <p className="text-red-600 text-sm">{error}</p>}
        <button
          type="submit"
          className="w-full bg-black text-white py-2 rounded hover:bg-gray-800"
        >
          Login
        </button>
      </form>
    </div>
  );
};

export default AdminLogin;
